import style from './SectionTitle.module.scss'

interface IProps {
    header: string
    description: string
}

export const SectionTitle = (props: IProps) => {
    const { header, description } = props
    return (
        <div className={style.container}>
            <div className={style.title}>
                <span>{header}</span>
            </div>
            <div className={style.description}>
                <span>{description}</span>
            </div>
        </div>
    )
}
